export default __webpack_public_path__ + "static/media/offline.7d04c1c6.png";